<template>
	<vx-card no-shadow>
		<div>
			<vs-input
				id="file-upload"
				type="file"
				accept=".json"
				v-validate="'required'"
				class="mt-3 w-full mb-4"
				@change="onFileChange"
			/>

			<div class="custom-file-upload flex items-center" for="file-upload">
				<label for="file-upload" class="custom-file-upload__icon" :class="uploadStatus">
					<feather-icon class="cursor-pointer mr-2" icon="PaperclipIcon" svgClasses="h-8 w-8" />
				</label>
				<label for="file-upload" class="custom-file-upload__text" :class="uploadStatus">
					{{ this.dataFile ? this.fileName : $t("MassiveAssignment.MassiveAssignmentUploadFile") }}
				</label>
			</div>

			<div class="mt-4 mb-2">
				<vs-progress :height="12" :percent="progressPercent" :color="progressColor"></vs-progress>
			</div>
		</div>

		<div no-shadow v-if="dataFile">
			<div v-if="!activeAlert">
				<p class="text-xl font-medium">
					<span>{{ $t("UploadFiles.Details") }}:</span>
				</p>
				<p class="text-md font-medium text-success" v-if="fileType === 'resources'">
					<span>{{ $t("Resources") }}:</span>
					<span class="ml-1">{{ jsonResult.resources.length }}</span>
				</p>
				<p class="text-md font-medium text-success" v-if="fileType === 'visitPoints'">
					<span>{{ $t("VisitPoints") }}:</span>
					<span class="ml-1">{{ jsonResult.visitPoints.length }}</span>
				</p>
			</div>
			<div>
				<vs-alert
					:active.sync="activeAlert"
					closable
					icon-pack="feather"
					close-icon="icon-x"
					color="danger"
					:title="$t('Error')"
				>
					{{ $t("MassiveAssignment.LoadMassiveAssignmentUploadFileError") }}
				</vs-alert>
			</div>

			<div class="vx-row mt-base">
				<div class="vx-col w-1/2">
					<vs-button
						class="w-full"
						icon-pack="feather"
						icon="icon-check"
						@click.prevent="handleUpload"
						:disabled="enableUploadBtn || activeAlert"
						>{{ assignBtnText }}
					</vs-button>
				</div>
				<div class="vx-col w-1/2">
					<vs-button
						class="w-full"
						color="danger"
						type="border"
						icon-pack="feather"
						icon="icon-x"
						@click.prevent="cleanData"
						>{{ $t("Cancel") }}
					</vs-button>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";

import moduleResource from "@/store/resource/moduleResource.js";

export default {
	components: {
		vSelect,
	},
	props: {
		fileType: {
			type: String,
		},
	},
	data() {
		return {
			percent: 0,
			dataFile: null,
			fileName: "",
			textStatus: "",
			progressColor: "success",
			activeAlert: false,
			jsonResult: {
				resources: [],
				visitPoints: [],
			},
		};
	},
	computed: {
		enableUploadBtn() {
			return !this.dataFile;
		},
		uploadStatus() {
			if (this.textStatus === "success") return "text-success";
			else if (this.textStatus === "error") return "text-danger";
			else return "";
		},

		fileSize() {
			const fileBytes = this.dataFile.size;
			if (fileBytes >= 1073741824) {
				return (fileBytes / 1073741824).toFixed(2) + " GB";
			} else if (fileBytes >= 1048576) {
				return (fileBytes / 1048576).toFixed(2) + " MB";
			} else if (fileBytes >= 1024) {
				return (fileBytes / 1024).toFixed(2) + " KB";
			} else if (fileBytes > 1) {
				return fileBytes + " bytes";
			} else if (fileBytes == 1) {
				return fileBytes + " byte";
			} else {
				return "0 bytes";
			}
		},
		progressPercent: {
			get() {
				return this.percent;
			},
			set(val) {
				this.percent = val;
			},
		},
		assignBtnText() {
			return this.$t("Select");
		},
	},
	methods: {
		handleFileLoad(event) {
			if (this.dataFile.type === "application/json") {
				this.jsonResult = JSON.parse(event.target.result);
				this.fileName = this.dataFile.name;
				this.progressPercent = 100;
				this.textStatus = "success";
				this.progressColor = "success";
			} else {
				this.activeAlert = true;
			}
		},
		handleUpload() {
			if (this.fileType === "visitPoints") {
				this.$store.commit("moduleVisitPoint/SET_VISIT_POINT_CHECKED", this.jsonResult.visitPoints);
			}
			if (this.fileType === "resources") {
				this.$store.commit("moduleResource/SET_SELECTED_RESOURCE_PAGES", this.jsonResult.resources);
			}

			this.$emit("uploadStatusEmit", this.jsonResult);

			this.fileName = "Seleccionar Archivo";
			this.progressPercent = 0;
			this.dataFile = null;
			this.textStatus = "";
		},
		successUpload() {
			this.$vs.notify({
				color: "success",
				title: this.$t("UploadFiles.UploadSuccess"),
				text: this.$t("UploadFiles.UploadSuccessMessage"),
			});
		},
		errorUploadNotify(message) {
			this.$vs.notify({
				color: "danger",
				title: "Upload Error",
				text: message,
			});
		},
		onFileChange(e) {
			const reader = new FileReader();
			reader.onload = this.handleFileLoad;
			reader.readAsText(e.target.files[0]);
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.dataFile = files[0];
		},

		cleanData() {
			this.fileName = "Seleccionar Archivo";
			this.progressPercent = 0;
			this.dataFile = null;
			this.textStatus = "";
			//this.$store.commit("moduleVisitPoint/SET_VISIT_POINT_CHECKED", []);
			//this.$store.commit("moduleResource/SET_SELECTED_RESOURCE_PAGES", []);
			this.$emit("uploadCancelEmit");
		},
		showSuccessUpload() {
			this.activeAlert = true;
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
	mounted() {},
};
</script>

<style lang="css" scope>
#upload-file-content {
	height: 100%;
}

input[type="file"] {
	display: none;
}

.custom-file-upload {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border: 1px solid #f3f3f3;
	border-radius: 5px;
	height: 100px;
}

.custom-file-upload:hover {
	border: 1px solid #979797;
}

.custom-file-upload__icon {
	padding: 50px 50px 0px 50px;
}

.custom-file-upload__text {
	padding: 0px 50px 50px 50px;
}

.custom-heigh {
	height: 70vh;
}
</style>
